import React, { useEffect, useState } from "react";
import keys from "../store/keys";
import { Link, NavLink } from "react-router-dom";
import { setKey, getKey, setStringifiedKey, clearKeys } from "../store/actions";
import { connect } from "react-redux";
import utils from "../utils/utils";
import subscriptionService from "../services/subscription";

function Footer({ session, setKey, setStringifiedKey, clearKeys, ...props }) {

	const [errorMessage, setErrorMessage] = useState('');
	const [successMessage, setSuccessMessage] = useState('');
	const [email, setEmail] = useState('');

	const handleSubmit = e => {
		e.preventDefault();
		setErrorMessage('');
		setSuccessMessage(``);
		if (!email || email.length === 0) {
			setErrorMessage(`Email address is required.`);
			return;
		} else {
			if (!utils.isValidEmail(email)) {
				setErrorMessage(`Please provide a valid email address.`);
				return;
			}
		}

		setKey(keys.isLoading, true);
		subscriptionService.signup({email})
			.then(result => {
				if (result.error) {
					setErrorMessage(result.error);
					setKey(keys.isLoading, false);
					return;
				}

				setErrorMessage('');
				setSuccessMessage(`Signup successful! Thank you.`);
				setKey(keys.isLoading, false);
			});
	}

	return (
		<div className="container-fluid bg-dark text-white footer">
			<div className="row" style={{paddingLeft: 100, paddingRight: 100, paddingTop: 50, paddingBottom:10}}>
				<div className="col-3">
					<div className="footer-heading">TRADE</div>
					<div className="mt-2">Trade Program</div>
					<div className="footer-heading mt-20">SELLERS</div>
					<div className="mt-2">Seller Applications</div>
					<div className="mt-2">Seller Login</div>
					<div className="mt-2">Seller Directory</div>
				</div>
				<div className="col-3">
					<div className="footer-heading">OUR COMPANY</div>
					<div className="mt-2">About Us</div>
					<div className="mt-2">Contact 1stDibs</div>
					<div className="mt-2">Support Center</div>
					<div className="mt-2">Press</div>
					<div className="mt-2">Careers</div>
					<div className="mt-2">Investors</div>
				</div>
				<div className="col-3">
					<div className="footer-heading">CATEGORIES</div>
					<div className="mt-2">Furniture</div>
					<div className="mt-2">Jewelry & Watches</div>
					<div className="mt-2">Fine Arts</div>
					<div className="mt-2">Fashion</div>
					<div className="mt-2">Creators</div>
					<div className="mt-2">Questions & Answers</div>
				</div>
				<div className="col-3">
					<div className="footer-heading">CONTACT WITH US</div>
					
					<div className="row mt-30">
					<small>
						Signup for weekly emails with new listing, sales and more!
					</small>
					</div>
					<div className="row">
						<div className="col-8">
							<input 
								type="text" 
								className="form-control shadow-none" 
								placeholder="Yes, here's my email"
								value={email}
								onChange={e => {setErrorMessage(""); setEmail(e.target.value)}}></input>
						</div>
						<div className="col-4">
							<button className="btn btn-dark shadow-none" onClick={handleSubmit}>SUBSCRIBE</button>
						</div>
					</div>
					<div className="row">
						<div className="col">
							{errorMessage && <small className="text-danger mb-2">{errorMessage}</small>}
							{successMessage && <small className="text-success mb-2">{successMessage}</small>}
						</div>
					</div>
					<div className="row mt-2">
						<small>
							By entering your email, you are agree to our <a href="#" target="_blank">User Agreement</a> and <a href="#" target="_blank">Privacy Policy</a>.
						</small>
					</div>
					<div className="row mt-2">
						<p>Blog</p>
						<p>Magazine</p>
						<p>
							<i className="fa-brands fa-twitter"></i>
							<i className="fa-brands fa-facebook"></i>
							<i className="fa-brands fa-pinterest"></i>
							<i className="fa-brands fa-instagram"></i>
						</p>
					</div>
				</div>
			</div>
			<hr/>
			<div className="row">
				<div className="col">
					<p>
						&copy; Montells Inc. 2022
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;User Agreement
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Privacy Policy
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Do Not Sell My Info
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Site Map
					</p>
					<p>
						This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.
					</p>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = (store) => ({
	session: store.session,
});

const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
	setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value)),
	clearKeys: () => dispatch(clearKeys()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
